// Product images for warehouse items
export const PRODUCT_IMAGES = [
  'https://images.unsplash.com/photo-1586769852836-bc069f19e1b6?w=800&q=80', // LED panel
  'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80', // Electrical components
  'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&q=80', // Industrial lights
  'https://images.unsplash.com/photo-1604762524889-4573f0d6e494?w=800&q=80', // Ceiling light fixture
  'https://images.unsplash.com/photo-1565084888279-aca607ecce0c?w=800&q=80', // Light bulbs
];

/**
 * Get a product image by index
 * @param index - Index of the product image (0-4)
 * @returns Product image URL
 */
export const getProductImage = (index: number): string => {
  return PRODUCT_IMAGES[index % PRODUCT_IMAGES.length];
};

/**
 * Get a random product image
 * @returns Random product image URL
 */
export const getRandomProductImage = (): string => {
  const randomIndex = Math.floor(Math.random() * PRODUCT_IMAGES.length);
  return PRODUCT_IMAGES[randomIndex];
};
